var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.294922,
    y: 0.0634766,
    width: 55.8809,
    height: 55.8809,
    rx: 14,
    fill: "#FFF5CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5201 28.004C32.5201 30.3709 30.6013 32.2897 28.2344 32.2897C25.8674 32.2897 23.9487 30.3709 23.9487 28.004C23.9487 25.637 25.8674 23.7183 28.2344 23.7183C30.6013 23.7183 32.5201 25.637 32.5201 28.004ZM32.5201 28.004V29.4325C32.5201 31.0105 33.7993 32.2897 35.3772 32.2897C36.3909 32.2897 37.2812 31.7618 37.7884 30.966C38.0708 30.523 38.2344 29.9969 38.2344 29.4325V28.004C38.2344 22.4811 33.7572 18.004 28.2344 18.004C22.7115 18.004 18.2344 22.4811 18.2344 28.004C18.2344 33.5268 22.7115 38.004 28.2344 38.004C30.359 38.004 32.3289 37.3414 33.9487 36.2116",
    stroke: "#FFCB04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e8602172f1e1b251d2fe25e645c8a5f1.svg";
export { ForwardRef as ReactComponent };